/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/content_optimizer_steps" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasContentOptimizerSteps } from "./constants";
import type { EngagementAppGroupIdCanvasContentOptimizerStepsResult } from "./types";

export const getEngagementAppGroupIdCanvasContentOptimizerSteps = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasContentOptimizerSteps,
  (
    signal: AbortSignal,
    appGroupId: string,
    reportId: string,
    startDate: number,
    endDate: number,
    dashboardId: string
  ): Promise<EngagementAppGroupIdCanvasContentOptimizerStepsResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas/content_optimizer_steps`,
      "GET",
      {
        report_id: reportId,
        start_date: startDate,
        end_date: endDate,
        // An empty string means the report is not a dashboard tile; omit it so the backend sees nil
        dashboard_id: dashboardId || undefined,
      },
      { signal }
    );
  }
);
